<template>
  <Form 
    :d_form='form'
    :d_lkp_negeri='lkp_negeri'
    v-if="id > 0 && load == 2"
  />
  <Form 
    :d_form='form'
    :d_lkp_negeri='lkp_negeri'
    v-else-if="id == 0 && load == 1"
  /> 
  <Form 
    :d_form='form'
    :d_lkp_negeri='lkp_negeri'
    v-else-if="id == 0 && load == 2"
  /> 
</template>



<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'
import Form from "./_From.vue";

export default {
  extends: ZResource,
  components: {
    Form
  },
  props: {
    id: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'pdbf.penilaian',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        // { label: 'Daftar Tangki LN2', route: '/tangki' },
        { label: 'Permohonan Perkhidmatan Penilaian Daya Biak & Fertiliti', route: '/pdbf/penilaian/form/0' },
      ],
      title : 'Permohonan Perkhidmatan Penilaian Daya Biak & Fertiliti',
      form : {
        id : 0,
        jantina :'',
        skor : 0,
        skortum : 0,
        berat : '',
        otot : '',
        sendi : '',
        postur : '',
        vulva : '',
        vulva_nyatakan: null,
        ambing : '',
        ambing_nyatakan: null,
        puting : '',
        puting_nyatakan: null,
        servik : '',
        bentuk : '',
        kekenyalan : '',
        saiz : '',
        testis : '',
        testis_nyatakan : null,
        epididymis : '',
        epididymis_nyatakan : null,
        korda :'',
        korda_nyatakan :'',
        penis :'',
        penis_nyatakan :'',
        ampullae :'',
        vesikal :'',
        prostat :'',
        trichnomoniasis :'',
        camplylobacteriosis : '',
        brucellosis :'',
        tanda_klinikan : '',
        temprament : '',
        lkp_negeri_id : '',
        lkp_status_id : '',
        lkp_ternakan_id : '',
        ulasan : '',
        kode : '',
        hantar : 0,
        p : 0,
        ternakan_list : [],
      },
      ternakan_list:[],
      premis : [],
      pemeriksa :[],
      juruteknik_list : [],
      lkp_ternakan : [],
      lkp_status : [],
      load : 0
      
      
    }
  },
  methods: {
    

      
 
     getData(){
      if(this.id > 0){
        this.$zcomm.get(this.api_service + 'pdbf/show_nilai/'+this.id, {}).then(res => {
          this.form = res
          this.load = this.load + 1
        })
      }
      
    },

    getSalin(id){
        this.$zcomm.get(this.api_service + 'pdbf/show/'+id, {}).then(res => {
          this.form = res
          this.form.id = 0
          this.load = this.load + 1
        })

       
      },

    getNegeri(){
         this.$zcomm.get(this.api_service + 'lookup/negeri/1', {}).then(res => {
            this.lkp_negeri = res
            this.load = this.load + 1
         })
    },

   
  
  },

  watch: {

  },
  mounted() {
    this.getData()
    this.getNegeri()
    this.params = location.search.slice(1).split('&').map(p => p.split('=')).reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
    if(this.params.salin && this.params.salin > 0){
      
      this.getSalin(this.params.salin)
    }
    
  }
    
}
</script>
